/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type JdbcDatasourceJobAction = {
    timeout?: number;
    type: JdbcDatasourceJobAction.type;
};

export namespace JdbcDatasourceJobAction {

    export enum type {
        GET_TABLES = 'GET_TABLES',
        GET_SCHEMAS_IN_DATABASE = 'GET_SCHEMAS_IN_DATABASE',
        EXECUTE_STATEMENT = 'EXECUTE_STATEMENT',
        EXECUTE_PREPARED_STATEMENT = 'EXECUTE_PREPARED_STATEMENT',
    }


}
